import { render, staticRenderFns } from "./IconSvgHeadphones.vue?vue&type=template&id=fb28993a&scoped=true&"
import script from "./IconSvgHeadphones.vue?vue&type=script&lang=js&"
export * from "./IconSvgHeadphones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb28993a",
  null
  
)

export default component.exports